import React from 'react';
import PropTypes from 'prop-types';
import Select from '@/modules/common/components/Select';
import '../styles/SelectStatusInternal.scss';

const options = [
    {title: 'Отказ', value: '-1'},
    {title: 'В процессе', value: '0'},
    {title: 'Принято', value: '1'},
];

const SelectStatusInternal = (props) => {
    return (
        <Select className="select-status-internal" options={options}
                label={(props.showLabel) ? 'Внутренний статус' : ''}
                {...props}
        />
    );
};

SelectStatusInternal.propTypes = {
    showLabel: PropTypes.bool,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    showEmpty: PropTypes.bool,
};

SelectStatusInternal.defaultProps = {
    showLabel: true,
    showEmpty: true,
};

export default SelectStatusInternal;
